class TypewriterAnnouncement extends HTMLElement {
  constructor() {
    super();
    this.messages = [];
    this.currentIndex = 0;
    this.charIndex = 0;
    this.isDeleting = false;
    this.typeSpeed = 60;
    this.deleteSpeed = 35;
    this.pauseAfterType = 2000;
    this.pauseAfterDelete = 500;
  }

  connectedCallback() {
    this.messages = JSON.parse(this.getAttribute('data-messages') || '[]');
    if (this.messages.length === 0) return;

    this.textEl = this.querySelector('.typewriter-text');
    this.cursorEl = this.querySelector('.typewriter-cursor');
    if (!this.textEl) return;

    this.tick();
  }

  tick() {
    const currentMsg = this.messages[this.currentIndex];

    if (!this.isDeleting) {
      this.charIndex++;
      this.textEl.textContent = currentMsg.substring(0, this.charIndex);

      if (this.charIndex === currentMsg.length) {
        this.isDeleting = true;
        setTimeout(() => this.tick(), this.pauseAfterType);
        return;
      }
      setTimeout(() => this.tick(), this.typeSpeed);
    } else {
      this.charIndex--;
      this.textEl.textContent = currentMsg.substring(0, this.charIndex);

      if (this.charIndex === 0) {
        this.isDeleting = false;
        this.currentIndex = (this.currentIndex + 1) % this.messages.length;
        setTimeout(() => this.tick(), this.pauseAfterDelete);
        return;
      }
      setTimeout(() => this.tick(), this.deleteSpeed);
    }
  }
}

customElements.define('typewriter-announcement', TypewriterAnnouncement);
